<div class="description-modal-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Snapshot Description</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onClose()"
      matTooltip="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Snapshot Info -->
  <div class="snapshot-info-header">
    <div class="snapshot-name">{{ data.snapshot.name }}</div>
    <div class="snapshot-meta">
      <span class="snapshot-date">{{
        data.snapshot.createdAt | date: "MMM d, yyyy 'at' h:mm a"
      }}</span>
      @if (data.snapshot.userName) {
        <span class="snapshot-author">by {{ data.snapshot.userName }}</span>
      }
    </div>
  </div>

  <!-- Description Content -->
  <div class="description-content">
    @if (data.snapshot.content && data.snapshot.content.trim()) {
      <div class="description-text">
        {{ data.snapshot.content }}
      </div>
    } @else {
      <div class="no-content">
        <mat-icon>description</mat-icon>
        <p>No description available for this snapshot.</p>
      </div>
    }
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button mat-button class="close-action-button" (click)="onClose()">
      Close
    </button>
  </div>
</div>
